import { Component, Input } from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { BCLedgerFilter } from "../../../../core/models/bcLedgers/bclegderfilter";
import { bcLedgerRouting } from "../../../../shared/constants/bcLedgerRouting";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { exportExcel } from "../../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { MiscComponent } from "../misc/misc.component";
import { SampleComponent } from "../sample/sample.component";
import { BacklogDetailsComponent } from "../backlog-details/backlog-details.component";
import { GpAdjustmentComponent } from "../gp-adjustment/gp-adjustment.component";
import { FreightComponent } from "../freight/freight.component";
import { SalesCommissionComponent } from "../sales-commission/sales-commission.component";
import { AdjustmentsComponent } from "../adjustments/adjustments.component";
import { NetsChargedComponent } from "../nets-charged/nets-charged.component";
import { YTDGPComponent } from "../ytdgp/ytdgp.component";
import { TotalApMiscComponent } from "../total-ap-misc/total-ap-misc.component";
import { CommissionsPaidTotalComponent } from "../commissions-paid-total/commissions-paid-total.component";
import { TotalSalesCommissionsAdjustmentsComponent } from "../total-sales-commissions-adjustments/total-sales-commissions-adjustments.component";
import { ChargeBackComponent } from "../charge-back/charge-back.component";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { BCLedgerTotalData } from "../../../../core/models/bcLedgers/bcLedgerTotalDataDto";

@Component({
  selector: "jni-total-bclegder",
  templateUrl: "./total-bclegder.component.html",
  styleUrls: ["./total-bclegder.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ModalStackerComponent,
    MiscComponent,
    SampleComponent,
    BacklogDetailsComponent,
    GpAdjustmentComponent,
    FreightComponent,
    SalesCommissionComponent,
    AdjustmentsComponent,
    NetsChargedComponent,
    YTDGPComponent,
    TotalApMiscComponent,
    CommissionsPaidTotalComponent,
    TotalSalesCommissionsAdjustmentsComponent,
    ChargeBackComponent,
    CardModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
  ],
})
export class TotalBclegderComponent {
  bcLedgerStacker: BcLedgerStacker = {} as BcLedgerStacker;
  @Input() totalBcLegderLists!: BCLedgerTotalData[];
  @Input() bcLedgerFilter!: BCLedgerFilter;
  fileName = "Totals";
  displayModal = false;

  clearTable(table: Table) {
    table.clear();
  }

  isBackground(description: string): boolean {
    description = description.replace(/[^a-zA-Z ]/g, "").replace(/\s/g, "");

    const routingList = bcLedgerRouting.filter(x => x.path == description);
    if (!routingList.length) {
      return true;
    }
    if (routingList[0].isBackground == true) {
      return true;
    }
    return false;
  }

  onDescriptionClick(description: string) {
    const brandingConsultantID = this.bcLedgerFilter.brandingConsultantID;

    const fromDate = new Date(
      this.bcLedgerFilter.fromDate ?? ""
    ).toLocaleDateString();
    const toDate = new Date(
      this.bcLedgerFilter.toDate ?? ""
    ).toLocaleDateString();
    description = description.replace(/[^a-zA-Z ]/g, "").replace(/\s/g, "");

    const routingList = bcLedgerRouting.filter(x => x.path == description);
    if (!routingList.length) {
      return;
    }
    this.bcLedgerStacker.Path = routingList[0].path;
    this.bcLedgerStacker.BrandingConsultantID = brandingConsultantID ?? "";
    this.bcLedgerStacker.FromDate = fromDate;
    this.bcLedgerStacker.ToDate = toDate;
    this.bcLedgerStacker.CategoryID = routingList[0].category;
    this.displayModal = true;
    // this._router.navigate([
    //   `bcledger/${routingList[0].path}`,
    //   brandingConsultantID,
    //   fromDate,
    //   toDate,
    //   routingList[0].category
    // ]);
  }

  closeBcLedgerModal() {
    this.displayModal = false;
  }
  // closeModalOnBcLedger() {
  //   this._sidebarService.selectedMenu$.subscribe((value) => {
  //     if (value === 'bc leger') {
  //       this.displayModal = false;
  //     }
  //   });
  // }
  exportExcelFile() {
    exportExcel(this.totalBcLegderLists, this.fileName);
  }
}
